import { baseErrorHandler } from "@queries/baseErrorHandler";
import { $api } from "@service/RequestService";
import { useQuery } from "react-query";

import { queryKeys } from "../constants";
import { TJMS } from "../models/ITJMS";

export const useGetAllTJMSWithBuildings = () =>
    useQuery<TJMS[]>(
        [queryKeys.TJMS],
        async () => {
            const res = await $api.get(`/v3/mobile/sale-plan/flat/house-building`);

            return res.data?.data;
        },
        {
            retry: false,
            refetchOnWindowFocus: false,
            onError: baseErrorHandler
        }
    );